import getBookingServicesOperation from 'owa-service/lib/operation/getBookingServicesOperation';
import type GetBookingServicesJsonResponse from 'owa-service/lib/contract/GetBookingServicesJsonResponse';
import type GetBookingServicesResponseMessage from 'owa-service/lib/contract/GetBookingServicesResponseMessage';
import type GetBookingServicesJsonRequest from 'owa-service/lib/contract/GetBookingServicesJsonRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';

/**
 * Service call to get booking meetingTypes.
 */
export async function getAllBookingMeetingTypes(): Promise<GetBookingServicesResponseMessage | null> {
    const request: GetBookingServicesJsonRequest = {
        Header: getJsonRequestHeader(),
        Body: {},
    };
    // Here we are not logging the mailbox hash of the organizer because we do not need to link organizer and attendee data
    const perfDatapoint = new PerformanceDatapoint('getAllBookingMeetingTypes');
    /* eslint-disable-next-line owa-custom-rules/require-getMailboxRequestOptions  -- (https://aka.ms/OWALintWiki)
     * MailboxReqestOptions should be passed into service request calls, see https://aka.ms/multiaccountlinter
     *	> All service requests calls must pass in a MailboxRequestOptions. The can be obtained by passing a MailboxInfo to the getMailboxRequestOptions function. */
    const response: GetBookingServicesJsonResponse = await getBookingServicesOperation(request);

    let result: GetBookingServicesResponseMessage | null = null;
    if (response?.Body) {
        result = response.Body;
        if (response.Body.ResponseClass === 'Success') {
            perfDatapoint.addCustomData({
                entryPoint: 'booking',
            });
            perfDatapoint.end();
        } else {
            const faultMessage: string | undefined = result.MessageText;
            const responseCode = result.ResponseCode;
            const responseClass = result.ResponseClass;
            perfDatapoint.addCustomData({
                entryPoint: 'booking',
                exceptionName: faultMessage,
                responseCode,
                responseClass,
            });
            perfDatapoint.endWithError(DatapointStatus.ServerError);
        }
    } else {
        perfDatapoint.endWithError(DatapointStatus.ServerError);
    }
    return result;
}
